import { Globals } from "@ortho-next/three-base";
import { Vector2 } from "three";
import { ViewType } from "../Models/AppModel.js";
import { bindedModelBase } from "../Models/BindedModel.js";
/**
 * Generates images for use in the print report.
 */
export class PrintUtilsBase {
    constructor(main, context) {
        this._main = main;
        this._context = context;
    }
    generateImage(printState) {
        bindedModelBase.printState = printState;
        this._main.multiviewRenderer.render();
        return this._main.renderer.domElement.toDataURL();
    }
    getRestoreData(target) {
        target.oldMultiViewsActive = this._main.multiViewsActive;
        target.oldActiveScene = this._main.activeScene;
        target.oldSize = new Vector2();
        this._main.renderer.getSize(target.oldSize);
        target.canvasContainerWidth = Globals.canvasContainer.style.width;
        target.canvasContainerHeight = Globals.canvasContainer.style.height;
    }
    restoreData(tempData) {
        bindedModelBase.printState = 0; //must be first name
        this.applyResize(tempData.oldSize.x, tempData.oldSize.y);
        Globals.canvasContainer.style.width = tempData.canvasContainerWidth;
        Globals.canvasContainer.style.height = tempData.canvasContainerHeight;
        if (!tempData.oldMultiViewsActive) {
            const view = tempData.oldActiveScene === this._main.scenes[ViewType.AP] ? ViewType.AP : ViewType.LT;
            this._main.setView(view);
        }
    }
    applyResize(width, height) {
        Globals.canvasContainer.style.width = `${width}px`;
        Globals.canvasContainer.style.height = `${height}px`;
        this._main.renderer.setSize(width, height); //this will generate an image with size * window.pixelRatio
        for (const scene of this._main.scenes) {
            scene.onWindowResize();
        }
        this._main.multiviewRenderer.onWindowResize();
    }
}
//# sourceMappingURL=PrintUtils.js.map